import { render, staticRenderFns } from "./StepsHeader.vue?vue&type=template&id=6ea910d6&scoped=true"
import script from "./StepsHeader.vue?vue&type=script&lang=js"
export * from "./StepsHeader.vue?vue&type=script&lang=js"
import style0 from "./StepsHeader.vue?vue&type=style&index=0&id=6ea910d6&prod&scoped=true&lang=scss"
import style1 from "./StepsHeader.vue?vue&type=style&index=1&id=6ea910d6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ea910d6",
  null
  
)

export default component.exports